export default __webpack_public_path__ + "static/media/ic_lifering.1dd07938.svg";